import { TaxRate as InvoiceTaxRate } from '@dreryk/egabinet-invoice-frontend-api';

import { Translate } from '@dreryk/react-common';
import { InteractiveTable, InteractiveTableCellProps } from '@dreryk/react-components';

import { invoiceCreateModalTranslationKeys } from '../../../translations';

import { getTaxRateCellDefaultValue, NEW_ROW_EMPTY_VALUE_PLACEHOLDER } from './InvoiceItemsTable.utils';

type InvoiceItemsTableTaxRateCellProps = InteractiveTableCellProps<InvoiceTaxRate>;

export const InvoiceItemsTableTaxRateCell = (props: InvoiceItemsTableTaxRateCellProps): JSX.Element => {
   return (
      <InteractiveTable.CustomCell
         defaultValue={getTaxRateCellDefaultValue(props.defaultValue)}
         index={props.index}
         name={props.name}
         testId={props.testId}
      >
         {(value) => {
            if (!value) {
               return <>{NEW_ROW_EMPTY_VALUE_PLACEHOLDER}</>;
            }
            return <Translate>{invoiceCreateModalTranslationKeys.table.taxRateMap[value]}</Translate>;
         }}
      </InteractiveTable.CustomCell>
   );
};
